<template>
  <div class="bg-gray20">
    <div class="container BODY-CONTAINER">
      <transition name="fade" mode="out-in">
        <div class="d-flex fd-column ai-center">
          <vk-icon
              class="c-red p-b-5"
              name="close-circle-filled"
              size="72"
          />
          <div class="h3 text-center">Something went wrong</div>
          <div class="text-center">
            Please try again to subscribe to text messages and stop receiving e-mails
          </div>
          <div class="p-y-5">
            <router-link :to="{name: 'consumer::dashboard'}" class="btn-secondary ROUNDED m-r-2">
              <span class="p-x-1">View My Account</span>
            </router-link>
            <button
                class="btn ROUNDED"
                @click="accept"
            >Get Updates via Text
            </button>
          </div>
          <div class="p-t-5">Pro Referral may send you text messages about this service request.
          Message & data rates may apply.
          Texts message frequency varies and may be sent between 8:00 am & 9:00 pm.
          Text STOP to cancel or HELP for help. For questions, contact 1-855-723-2266.
            <router-link :to="{ name: 'about::legal::privacy' }" class="link">
              Privacy & Security Statement
            </router-link>
          </div>

        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import workOrder from '@/mixins/work-order';
import authWithToken from '@/mixins/auth-token';
import http from '@homeservices/api-kit/axios';

export default {
  name: 'opt-in-error',
  components: {

  },
  mixins: [
    workOrder,
    authWithToken,
  ],
  computed: {
    ...mapGetters('user', [
      'isPro',
      'isLoggedIn',
    ]),
    token () {
      return this.$route.query.token;
    },
    jobId () {
      return this.$route.query.job_id;
    },
  },
  async mounted () {
    if (!this.isLoggedIn || this.isPro) {
      await this.authenticateWithToken(this.token);
    }
    if (!this.workOrder) {
      await this.fetchWorkOrder({ orderHash: this.jobId, includePublicProfiles: true });
    }
  },
  methods: {
    async decline () {
      this.$router.push({
        path: '/dashboard',
      });
    },
    async accept () {
      try {
        await http.put(`/platform/workorder/r/workorder/sms/optin/v2?work_order_hash=${this.jobId}`);
        this.$router.push({
          name: 'consumer::opt-in::success',
        });
      } catch (error) {
        this.$router.push({
          name: 'consumer::opt-in::error',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.BODY-CONTAINER {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  max-width: 780px;
  @include mobile-only() {
    max-width: 95vw;
  }
}
.ROUNDED {
  border-radius: 5px;
}
</style>
